<div class="row" *ngIf="w">
  <div class="col-lg-4">
    <div>
      <h3>Widget Size</h3>
      <select [(ngModel)]="w.size" class="input-group form-control  form-select">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-4" *ngIf="dashboards">
    <h3>Dashboard ID</h3>
    <select [(ngModel)]="w.dashboardId" class="input-group form-control  form-select" (change)="populateSites()">
      <option *ngFor="let dash of dashboards" [value]="dash.dashboardId">{{dash.name}}</option>
    </select>
  </div>
  <div class="col-lg-4" *ngIf="dashboards && siteType && sites">
    <h3>Site ({{siteType.siteTypeCode}})</h3>
    <select [(ngModel)]="w.siteUri" class="input-group form-control  form-select">
      <option *ngFor="let site of sites" [value]="site.siteUri">{{site.siteName}}</option>
    </select>
  </div>
</div>
